module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1600-f41eef2142089a2294c68491d8681e0e.webp";